import classNames from "classnames";
import { DotsModal, IBtnAction } from "dots-ui/dotsModal";
import { ReactNode, useContext, useMemo } from "react";
import { AvisContext } from "../../context/AvisContext";

interface IAvisModalProps {
  children: ReactNode;
  className?: string;
  isOpen: boolean | undefined;
  title?: string;
  confirmButtonText?: string;
  confirmButtonTextSuffix?: string;
  confirmButtonDisabled?: boolean;
  cancelButtonText?: string;
  hideConfirm?: boolean;
  additionalActions?: IBtnAction[];
  modalHeight?: string;
  onConfirm?: () => void;
  onClose?: () => void;
}
export function AvisModal(props: IAvisModalProps) {
  const {
    className,
    isOpen,
    title,
    confirmButtonText,
    confirmButtonTextSuffix,
    confirmButtonDisabled,
    cancelButtonText,
    hideConfirm,
    modalHeight,
    onConfirm,
    onClose,
    children,
    additionalActions = [],
  } = props;

  const { res } = useContext(AvisContext);

  const classNameAvisModal = classNames("avis-modal", className);
  const confirmButtonTextInner = confirmButtonText ?? res("button_Add");
  const cancelButtonTextInner = cancelButtonText ?? res("button_Cancel");
  const confirmButtonTextWSuffix = confirmButtonTextSuffix
    ? `${confirmButtonTextInner} ${confirmButtonTextSuffix}`
    : confirmButtonTextInner;

  const buttonSet = useMemo(() => {
    return [
      ...additionalActions,
      {
        action: "cancel",
        text: cancelButtonTextInner,
      } as IBtnAction,
      ...(!hideConfirm
        ? [
            {
              action: onConfirm,
              text: confirmButtonTextWSuffix,
              disabled: confirmButtonDisabled,
              className: "primary",
            } as IBtnAction,
          ]
        : []),
    ];
  }, [
    additionalActions,
    cancelButtonTextInner,
    confirmButtonDisabled,
    confirmButtonTextWSuffix,
    hideConfirm,
    onConfirm,
  ]);
  return (
    <DotsModal
      className={classNameAvisModal}
      isOpen={isOpen}
      onConfirm={onConfirm}
      onClose={onClose}
      title={title}
      hideClose={true}
      buttons={buttonSet}
      modalHeight={modalHeight}
    >
      {children}
    </DotsModal>
  );
}
